/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import axios from "axios";
import config from './../config'


export class Reports {
  static REPORTS_BASE_URI = "/public/ca/uim/reports/library";

  static get(path, cabiInfo = {}) {
    if (path == "customreports") {
      const userUrl = `/cabi/api/user-reports`;
      const postbody = {
        jaspertoken: cabiInfo.token,
        orgidl: cabiInfo.orgidl,
      };
      let promise = new Promise((resolve, reject) => {

        axios.post(userUrl, postbody).then(
          (data1) => {
            const customReports = data1.data;
            const reports = [];
            customReports.forEach((item) => {
              const reportUnitPath = item.uri;
              // Derive the parent folder from the full reportUnitPath
              const reportParent = reportUnitPath.split("/").pop().split("/");
              item.reportURL =
                cabiInfo.address +
                "/flow.html?_flowId=viewReportFlow&decorate=no&standAlone=true" +
                "&ParentFolderUri=" +
                encodeURIComponent(reportParent) +
                "&reportUnit=" +
                encodeURIComponent(reportUnitPath);

              item.scheduleURL =
                cabiInfo.address +
                "/scheduler/main.html?" +
                "reportUnitURI=" +
                encodeURIComponent(reportUnitPath) +
                "&resourceType=ReportUnit" +
                "&parentReportUnitURI=" +
                "#" +
                reportUnitPath;
              reports.push(item);
            });
            let data = {
              data: {
                resourceLookup: reports,
              },
            };
            resolve(data);
          },
          (error) => {
            reject(error);
          }
        )

      });
      return promise;
    } else {
      const folderUri = path
        ? `${Reports.REPORTS_BASE_URI}/${path}`
        : Reports.REPORTS_BASE_URI;
      const fullUrl = `/cabi/api/folder-info`;
      const postbody = {
        folderUri: folderUri,
        jaspertoken: cabiInfo.token,
        orgidl: cabiInfo.orgidl,
      };
      let promise = new Promise((resolve, reject) => {

        axios.post(fullUrl, postbody).then(
          (data) => {
            const folderResources = data.data.resourceLookup;
            // augment any reports with a redirect url
            folderResources.forEach((item) => {
              if (item.resourceType === "reportUnit") {
                const reportUnitPath = item.uri;
                // Derive the parent folder from the full reportUnitPath
                const reportParent = reportUnitPath
                  .split("/")
                  .pop()
                  .split("/");
                item.reportURL =
                  cabiInfo.address +
                  "/flow.html?_flowId=viewReportFlow&decorate=no&standAlone=true" +
                  "&ParentFolderUri=" +
                  encodeURIComponent(reportParent) +
                  "&reportUnit=" +
                  encodeURIComponent(reportUnitPath);

                item.scheduleURL =
                  cabiInfo.address +
                  "/scheduler/main.html?" +
                  "reportUnitURI=" +
                  encodeURIComponent(reportUnitPath) +
                  "&resourceType=ReportUnit" +
                  "&parentReportUnitURI=" +
                  "#" +
                  reportUnitPath;
              }
            });
            //making a call to get custom reports
            if (Reports.REPORTS_BASE_URI === folderUri) {
              const userUrl = `/cabi/api/user-reports`;
              const postbody = {
                jaspertoken: cabiInfo.token,
                orgidl: cabiInfo.orgidl,
              };
              axios
                .post(userUrl, postbody)
                .then((data1) => {
                  const customReports = data1.data;
                  if (customReports != undefined && (Array.isArray(customReports) && customReports.length != 0)) {
                    let customReportFolder = {
                      description: "",
                      inputControls: null,
                      label: "Custom Reports",
                      reportCount: customReports.length,
                      resourceType: "folder",
                      uri: "/public/ca/uim/reports/library/customreports",
                    };
                    data.data.resourceLookup.push(customReportFolder);
                  }

                  resolve(data);
                })
                .catch((error) => {
                  resolve(data);
                });
            } else {
              resolve(data);
            }
          },
          (error) => {
            reject(error);
          }
        )

      });

      return promise;
    }
  }

  static getSlaQosData() {
    return axios.get([config.basename, 'api/getQosReport'].join('/'));
  }
}
